<template>
  <v-navigation-drawer class="navigation-drawer"
    permanent
    :width="fullSize ? 220 : 60"
  >
    <setup-miner-dialog :show="showSetupDialog" @closeDialog="closeDialog" />
    <v-list>
      <v-list-item @click="goto(item.routeName)"
        v-for="item in menuItems"
        :key="item.routeName"
        link
      >
        <v-list-item-icon>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-item-icon>

        <v-list-item-content v-if="fullSize">
          <v-list-item-title>{{ ($t('route.' + item.routeName)).toUpperCase() }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <template #append>
      <v-list-item @click="clickShowDialog" class="setup-device">
        <v-list-item-icon>
          <v-icon>mdi-cog-outline</v-icon>
        </v-list-item-icon>
        <v-list-item-content v-if="fullSize">
          <v-list-item-title>{{ $t('nav.setupDevice').toUpperCase() }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
  </v-navigation-drawer>
</template>

<script>
import { menu } from '@/router/menu'
import setupMinerDialog from '@/components/SetupMinerDialog.vue'

export default {
  components: {
    setupMinerDialog
  },
  props: ['fullSize'],
  data () {
    return {
      showSetupDialog: false
    }
  },
  computed: {
    currenUser () {
      return JSON.parse(localStorage.getItem('user'))
    },
    menuItems () {
      const user = this.currenUser
      if (!user) return []
      return menu.filter(m => m.authorize.includes(user.role))
    }
  },
  methods: {
    goto (route) {
      if (this.$route.name !== route) this.$router.push({ name: route })
    },
    closeDialog () {
      this.showSetupDialog = false
    },
    clickShowDialog () {
      this.showSetupDialog = true
    }
  }
}
</script>

<style scoped>
</style>
